
// Utilidades
import * as React from 'react';
import "./App.css";
import Container from '@mui/material/Container';


import { Outlet, useNavigate, useNavigation, useLocation } from "react-router";
// import useAuth from "./hooks/useAuth";
// import { logout } from "./utils/auth";

// Estilos
import { ThemeProvider, createTheme, getContrastRatio } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';


import { useCookies } from 'react-cookie';
// import Navbar from './components/Navbar';
import NavbarBottom from './components/navbarBottom';
import { TablonProvider } from "./contexts/contextGeneral";
import { ToastContainer} from "react-toastify";

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#677d89ff',
      contrastText: getContrastRatio("#094b88", '#fff') > 4.5 ? '#fff' : '#111',
    },
    secondary: {
      main: '#f9aa33',
      contrastText: getContrastRatio("#f9aa33", '#fff') > 4.5 ? '#fff' : '#111',
    },
    white2: {
      main: '#fff',
      contrastText: getContrastRatio("#fff", '#fff') > 4.5 ? '#fff' : '#111',
    },
    comun: {
      main: '#9E9E9E',
      contrastText: getContrastRatio("#9E9E9E", '#fff') > 4.5 ? '#fff' : '#111',
    },
    pcomun: {
      main: '#4CAF50',
      contrastText: getContrastRatio("#4CAF50", '#fff') > 4.5 ? '#fff' : '#111',
    },
    raro: {
      main: '#2196F3',
      contrastText: getContrastRatio("#2196F3", '#fff') > 4.5 ? '#fff' : '#111',
    },
    epico: {
      main: '#9C27B0',
      contrastText: getContrastRatio("#9C27B0", '#fff') > 4.5 ? '#fff' : '#111',
    },
    legendario: {
      main: '#FF9800',
      contrastText: getContrastRatio("#FF9800", '#fff') > 4.5 ? '#fff' : '#111',
    },
    mitico: {
      main: '#F44336',
      contrastText: getContrastRatio("#F44336", '#fff') > 4.5 ? '#fff' : '#111',
    },
  },
});
const theme2 = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#094b88',
      contrastText: getContrastRatio("#094b88", '#fff') > 4.5 ? '#fff' : '#111',
    },
    secondary: {
      main: '#f9aa33',
      contrastText: getContrastRatio("#f9aa33", '#fff') > 4.5 ? '#fff' : '#111',
    },
    white2: {
      main: '#fff',
      contrastText: getContrastRatio("#fff", '#fff') > 4.5 ? '#fff' : '#111',
    },
    noaplica: {
      main: '#999999',
      contrastText: "#fff",
    },
    recibido: {
      main: '#c92121',
      contrastText: getContrastRatio("#c92121", '#fff') > 4.5 ? '#fff' : '#111',
    },
    proceso: {
      main: '#efdc12',
      contrastText: getContrastRatio("#efdc12", '#fff') > 4.5 ? '#fff' : '#111',
    },
    terminado: {
      main: '#008000',
      contrastText: getContrastRatio("#008000", '#fff') > 4.5 ? '#fff' : '#111',
    },
    comun: {
      main: '#9E9E9E',
      contrastText: '#fff',
    },
    pcomun: {
      main: '#4CAF50',
      contrastText: getContrastRatio("#4CAF50", '#fff') > 4.5 ? '#fff' : '#111',
    },
    raro: {
      main: '#2196F3',
      contrastText: getContrastRatio("#2196F3", '#fff') > 4.5 ? '#fff' : '#111',
    },
    epico: {
      main: '#9C27B0',
      contrastText: getContrastRatio("#9C27B0", '#fff') > 4.5 ? '#fff' : '#111',
    },
    legendario: {
      main: '#FF9800',
      contrastText: getContrastRatio("#FF9800", '#fff') > 4.5 ? '#fff' : '#111',
    },
    mitico: {
      main: '#F44336',
      contrastText: "#fff",
    },
  },
});

export default function ButtonAppBar() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, [pathname]);

  const navigation = useNavigation();
  const isLoading = navigation.state === "loading";
  const [themeSelect, setThemeSelect] = React.useState(theme2);
  const [cookies, setCookie] = useCookies(["theme"]);



  const handleTheme = () => {
    if (cookies.theme === 'light') {
      setCookie('theme', 'dark', { path: '/' });
      setThemeSelect(theme)
    } else {
      setCookie('theme', 'light', { path: '/' });
      setThemeSelect(theme2)
    }
  }

  const navigate = useNavigate();

  const [ordenes] = React.useState(null);
  const [orden] = React.useState(null);

  return (
    <div>
      <ThemeProvider theme={themeSelect}>
        <CssBaseline />
        {/* <Navbar navigate={navigate} handleTheme={handleTheme} /> */}
        {/* <main style={{margin: "10px"}}>
      </main> */}
        <TablonProvider
          initial={{
            ordenes,
            orden
          }}
        >
          <div className="spaceblank"></div>
          <Container maxWidth="md">
            <Outlet />

          </Container>
          <div className="spaceblankBottom"></div>
          <NavbarBottom navigate={navigate} />
        </TablonProvider>
      </ThemeProvider>
      <ToastContainer autoClose={1000} draggablePercent={40} />
    </div>
  );
}

